import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";
import { LoadingDots } from "@/components/_molecules/loading-dots/loading-dots";
import { cn } from "@/lib/cn";

interface AcceptInviteButtonProps {
  isLoading: boolean;
  type?: "button" | "submit";
  onClick?: () => void;
}

export const AcceptInviteButton: FC<AcceptInviteButtonProps> = ({ isLoading, type = "button", onClick }) => {
  const { t } = useTranslation("auth");

  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={isLoading}
      variant="default"
      aria-label={t("invite.acceptInvite")}
      className={cn("h-10 w-48 items-center justify-center text-sm", isLoading && "cursor-not-allowed bg-muted")}
    >
      {isLoading ? (
        <LoadingDots color="currentColor" className="text-muted-foreground" />
      ) : (
        <p>{t("invite.acceptInvite")}</p>
      )}
    </Button>
  );
};
